<template>
  <div class="main full-height">
    <div class="legal-content frosted">
      <button class="back-button-top" @click="$router.back()">
        <img src="@/assets/images/back.svg" alt="Zurück">
        <span>Zurück</span>
      </button>

      <h1>Widerrufsbelehrung</h1>
      <p class="last-update">Stand: März 2026</p>

      <section>
        <h2>Widerrufsrecht</h2>
        <p>Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses.</p>
        <p>Um Ihr Widerrufsrecht auszuüben, müssen Sie uns mittels einer eindeutigen Erklärung (z. B. ein mit der Post versandter Brief, Telefax oder E-Mail) über Ihren Entschluss informieren, diesen Vertrag zu widerrufen. Sie können dafür das beigefügte Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.</p>
      </section>

      <section>
        <h2>Folgen des Widerrufs</h2>
        <p>Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie eine andere Art der Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt haben), unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist.</p>
      </section>

      <section class="highlighted-warning">
        <h2>Besonderer Hinweis zum vorzeitigen Erlöschen</h2>
        <p>Ihr Widerrufsrecht erlischt bei einem Vertrag über die Lieferung von nicht auf einem körperlichen Datenträger befindlichen <b>digitalen Inhalten</b> (z. B. Premium-Upgrades) vorzeitig, wenn Sie ausdrücklich zugestimmt haben, dass wir mit der Ausführung des Vertrags vor Ablauf der Widerrufsfrist beginnen, und Sie Ihre Kenntnis davon bestätigt haben, dass Sie durch Ihre Zustimmung mit Beginn der Ausführung des Vertrags Ihr Widerrufsrecht verlieren.</p>
        <p><i>Da wir das Upgrade sofort nach dem Kauf freischalten, erfolgt dieses Erlöschen des Widerrufsrechts unmittelbar mit dem Kaufabschluss.</i></p>
      </section>

      <section>
        <h2>Muster-Widerrufsformular</h2>
        <p>(Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden Sie es zurück.)</p>
        <p>An: [Name, Anschrift, E-Mail-Adresse einfügen]</p>
        <p>Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über den Kauf der folgenden Waren (*)/die Erbringung der folgenden Dienstleistung (*)</p>
        <p>Bestellt am (*)/erhalten am (*)</p>
        <p>Name des/der Verbraucher(s)</p>
        <p>Anschrift des/der Verbraucher(s)</p>
        <p>Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier)</p>
        <p>Datum</p>
        <p>(*) Unzutreffendes streichen.</p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WithdrawalView'
}
</script>

<style scoped>
.main {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--background);
}

.legal-content {
  max-width: 800px;
  width: 100%;
  padding: 30px;
  text-align: left;
  line-height: 1.6;
}

.back-button-top {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  color: var(--primary-color);
  font-weight: 600;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
}

.back-button-top img {
  width: 20px;
  filter: var(--icon-filter);
}

h1 {
  font-size: 1.8rem;
  margin-bottom: 10px;
}

h2 {
  font-size: 1.2rem;
  margin-top: 25px;
  margin-bottom: 10px;
  color: var(--primary-color);
}

.last-update {
  color: var(--tertiary-color);
  font-size: 0.9rem;
  margin-bottom: 30px;
}

section {
  margin-bottom: 20px;
}

p {
  margin-bottom: 15px;
  color: var(--primary-color);
  opacity: 0.9;
}

.highlighted-warning {
  background: rgba(255, 152, 0, 0.1);
  border-left: 4px solid var(--warning);
  padding: 15px 20px;
  border-radius: 4px;
}

.highlighted-warning h2 {
  color: var(--warning);
  margin-top: 0;
}
</style>
